
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-investor",
      function () {
        return require("private-next-pages/real-estate-investor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-investor"])
      });
    }
  